import React, { useState, useContext } from 'react';
import './autoHandle.scss';
import Button from '../../components/Button';
import Label from '../../components/Label';

import NeumorphicController from './NeumorphicController';
import LightModeController from './LightModeController';

import CardsContext from '../../visulas/contexts/cardStyleContext';
import ContainerStyleContext from '../../visulas/contexts/containerStyleDataContext';

export default function AutoHandle() {
  const [neumorphicVisible, toggleNeumorphic] = useState(false);
  const [lightModeVisible, toggleLightMode] = useState(false);
  const { cardStyle, setCardStyle } = useContext(CardsContext);
  const { containerStyleData, setContainerStyleData } = useContext(ContainerStyleContext);

  return (
    <div className="auto-handle-card-controller">
      <Label>Select one of the predefined styles from below</Label> <br />
      <Button label="Neumorphic" block onClick={() => toggleNeumorphic(true)} />
      {/* <Button label="Dark Mode" block disabled /> */}
      <Button label="Light Mode" block onClick={() => toggleLightMode(true)} />
      {/* <Button label="Light on Dark" block disabled />
      <Button label="Dark on Light" block disabled /> */}
      {neumorphicVisible &&
        <NeumorphicController
          toggleCardController={toggleNeumorphic}
          cardStyle={cardStyle}
          setCardStyle={setCardStyle}
          setContainerStyleData={setContainerStyleData}
          containerStyleData={containerStyleData}
        />
      }
      {lightModeVisible &&
        <LightModeController
          toggleCardController={toggleLightMode}
          cardStyle={cardStyle}
          setCardStyle={setCardStyle}
          setContainerStyleData={setContainerStyleData}
          containerStyleData={containerStyleData}
        />
      }
    </div>
  );
}
